import { TPartialVersionedResource } from 'app/queryProvider/interfaces';

export const onboardingVersionedResource: TPartialVersionedResource<'onboarding'> = {
  onboarding: {
    name: 'onboarding',
    version: 'v1',
    microService: 'rpm',
    serializer: null,
  },
};
